/* eslint-disable xss/no-mixed-html */

import React from 'react';
import PropTypes from 'prop-types';
import urls from './urls';
//import supported from '@mapbox/mapbox-gl-supported';
import CodeSnippet from '@mapbox/dr-ui/code-snippet';
//import Note from '@mapbox/dr-ui/note';
import { highlightHtml } from '@mapbox/dr-ui/highlight/html';
import * as helpers from '@mapbox/dr-ui/edit/helpers';
import ControlToggleSet from '@mapbox/mr-ui/control-toggle-set';

const viewport = `<meta name="viewport" content="initial-scale=1,maximum-scale=1,user-scalable=no" />`;
const css = `\tbody { margin: 0; padding: 0; }
\t#map { position: absolute; top: 0; bottom: 0; width: 100%; background:#ddd;}`;

const api_key = 'ojxo5NVYZoFGx0Wg74cmedol7dsulfrE9b1SwxSF';
const api_key_mapbox =
    'pk.eyJ1IjoiZWtnaXMiLCJhIjoiY2tzaDcyd2Y0MGZxODJ2bWJtazluYzJxaSJ9.iqs6o8w7rkGNZReqPr_hRQ';
const google_api_key = 'AIzaSyA9j-qrzhHm5wh_NiFZNq9bGiorrgCRJzg';

export default class Example extends React.Component {
    static defaultProps = {
        displaySnippet: true,
        height: 400
    };
    constructor(props) {
        super(props);
        this.state = {
            // unsupported: false,
            selectedFramework: 'mapbox'
        };
    }

    getContent(html) {
        let env = this.state.selectedFramework;
        let lines = html.split('\n');
        let content = '';
        let htmlGoogle = '';
        let htmlMapLibre = '';
        let htmlOL = '';
        let htmlLeaflet = '';
        let htmlMapbox = '';
        let isMapLibre = false,
            isOL = false,
            isLeaflet = false,
            isMapbox = false,
            isGoogle = false;
        for (let i = 0; i < lines.length; i++) {
            let line = lines[i];

            if (line.endsWith('maplibre')) {
                isMapLibre = true;
                isOL = false;
                isLeaflet = false;
                isMapbox = false;
                isGoogle = false;
                continue;
            }
            if (line.endsWith('mapbox')) {
                isMapbox = true;
                isMapLibre = false;
                isOL = false;
                isLeaflet = false;
                isGoogle = false;
                continue;
            }
            if (line.endsWith('openlayer')) {
                isOL = true;
                isMapLibre = false;
                isLeaflet = false;
                isMapbox = false;
                isGoogle = false;
                continue;
            }
            if (line.endsWith('leaflet')) {
                isLeaflet = true;
                isMapLibre = false;
                isOL = false;
                isMapbox = false;
                isGoogle = false;
                continue;
            }
            if (line.endsWith('google')) {
                isGoogle = true;
                isLeaflet = false;
                isMapLibre = false;
                isOL = false;
                isMapbox = false;
                continue;
            }
            if (!line.endsWith('end')) {
                if (isMapLibre) {
                    htmlMapLibre += line + '\n';
                }
                if (isMapbox) {
                    htmlMapbox += line + '\n';
                }
                if (isOL) {
                    htmlOL += line + '\n';
                }
                if (isLeaflet) {
                    htmlLeaflet += line + '\n';
                }
                if (isGoogle) {
                    htmlGoogle += line + '\n';
                }
            }

            if (!isMapLibre && !isOL && !isLeaflet && !isMapbox && !isGoogle)
                content += line + '\n';
        }
        if (env === 'openlayer') return content + htmlOL;
        else if (env === 'mapbox') return content + htmlMapbox;
        else if (env === 'leaflet') return content + htmlLeaflet;
        else if (env === 'google') return content + htmlGoogle;
        else return content + htmlMapLibre;
    }
    displayHTML(html) {
        html = this.getContent(html);
        let env = this.state.selectedFramework;
        this.componentDidMount();
        if (env === 'google') {
            return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>${this.props.frontMatter.title}</title>
${viewport}
<script src="${urls.js({ env: env })}"></script>
<style>
${css}
</style>
</head>
<body>
${html}
</body>
</html>`;
        }
        return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>${this.props.frontMatter.title}</title>
${viewport}
<script src="${urls.js({ env: env })}"></script>
<link href="${urls.css({ env: env })}" rel="stylesheet" />
<style>
${css}
</style>
</head>
<body>
${html}
</body>
</html>`;
    }

    renderHTML(html) {
        let env = this.state.selectedFramework;
        if (env === 'google') {
            return `<!DOCTYPE html>
<html>
<head>
<meta charset=utf-8 />
<title>${this.props.frontMatter.title}</title>
${viewport}
<script src='${urls.js({ env: env })}'></script>
<style>
    ${css}
</style>
</head>
<body>
${html}
</body>
<script>
</script>
</html>`;
        }
        return `<!DOCTYPE html>
<html>
<head>
<meta charset=utf-8 />
<title>${this.props.frontMatter.title}</title>
${viewport}
<script src='${urls.js({ env: env })}'></script>
<link href='${urls.css({ env: env })}' rel='stylesheet' />
<style>
    ${css}
</style>
</head>
<body>
${html}
</body>
<script>
</script>
</html>`;
    }

    renderSnippet() {
        const { html, location } = this.props;
        const code = this.displayHTML(html);
        const parsedCode = helpers.extractor(code);
        return (
            <div className="bg-white">
                <div id="code" className="relative">
                    <CodeSnippet
                        code={this.displayHTML(html)}
                        highlighter={() => highlightHtml}
                        edit={{
                            frontMatter: {
                                ...this.props.frontMatter,
                                pathname: location.pathname
                            },
                            head: viewport,
                            js: parsedCode.js,
                            html: parsedCode.html,
                            css: parsedCode.css,
                            resources: parsedCode.resources
                        }}
                    />
                </div>
            </div>
        );
    }
    render() {
        const { frontMatter, height } = this.props;
        return (
            <div className="prose">
                <iframe
                    id="demo"
                    style={{ height: height }}
                    className="w-full mt18"
                    allowFullScreen={true}
                    mozallowfullscreen="true"
                    webkitallowfullscreen="true"
                    ref={(iframe) => {
                        this.iframe = iframe;
                    }}
                    title={`${frontMatter.title} example`}
                />

                <ControlToggleSet
                    id="select-quickstart"
                    themeToggleGroup="bg-blue py3 px3 my12"
                    themeToggle="txt-s py3 toggle--white toggle--active-blue"
                    onChange={(value) => {
                        this.setState({ selectedFramework: value });
                    }}
                    value={this.state.selectedFramework}
                    options={[
                        {
                            label: 'Mapbox GL JS 2.0',
                            value: 'mapbox'
                        },
                        {
                            label: 'MapLibre GL JS',
                            value: 'maplibre'
                        },
                        {
                            label: 'OpenLayer',
                            value: 'openlayer'
                        },
                        {
                            label: 'Leaflet',
                            value: 'leaflet'
                        },
                        {
                            label: 'Google Map JS',
                            value: 'google'
                        }
                    ]}
                />
                {this.props.displaySnippet && this.renderSnippet()}
            </div>
        );
    }

    componentDidMount() {
        //if (!supported()) this.setState({ unsupported: true });
        let html = this.getContent(this.props.html);
        if (!this.iframe) return;
        html = this.renderHTML(html);
        html = html
            .replaceAll('{YOUR_API_KEY}', api_key)
            .replaceAll('{YOUR_API_KEY_MAPBOX_GL_JS}', api_key_mapbox)
            .replaceAll('{Google_Map_API_KEY}', google_api_key);
        const doc = this.iframe.contentWindow.document;
        doc.open();
        doc.write(html);
        doc.close();
    }
}

Example.propTypes = {
    html: PropTypes.string, // eslint-disable-line
    frontMatter: PropTypes.shape({
        title: PropTypes.string.isRequired
    }),
    location: PropTypes.shape({
        pathname: PropTypes.string
    }),
    displaySnippet: PropTypes.bool,
    height: PropTypes.number
};
